import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import { Fab, Card, TextField, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import SearchData from "../components/SearchData";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";

import DowloadBT from "../components/dowloadBT";
import { display } from "@mui/system";
import mime from "mime";
import { saveAs } from "file-saver";
function CustomToolbar() {
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport
        style={{
          color: "#84BD5A",
          borderColor: "#84BD5A",
          border: "1px solid #84BD5A",
        }}
        printOptions={{ disableToolbarButton: true}}
        csvOptions={{
          fields: ["FactoryName", "FactoryAddress", "FactoryMobile"],
          fileName: "FactoryData " + new Date() + Math.random(),
        }}
      />
    </GridToolbarContainer>
  );
}
export default function Customer() {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const [key,setKey] =useState('')
  
  const debouncedKey = useDebounce(key, 500);const [loading, setLoading] = useState(false)

  /* table data */
  const columns = [
    { field: "FactoryName", headerName: "FACTORY NAME", width: 250 },
    { field: "FactoryAddress", headerName: "FACTORY ADDRESS", width: 250 },
    { field: "FactoryMobile", headerName: "FACTORY PHONE", width: 200 },
    {
      field: "Status",
      headerName: "STATUS",
      width: 100,
      valueFormatter: ({ value }) =>
        value === true ? "ACTIVE" : "INACTIVE",
    },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/CustomerSupport/EditFactory/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
                // onClick={onClickEdit}
              >
                Edit
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //fetch Data
  const getData = async () => {
    try {
      const data = await api.get(`api/factory/list?keyword=${debouncedKey}`);
      // console.log(data);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [debouncedKey]);

  const download = async () => {
    setLoading(true)
    await api.get(`api/report/factory/download?keyword=${debouncedKey}`, {
      responseType: "blob",
      timeout: 30000
    })
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.xlsx", {
          type: mime.getType(".xlsx"),

        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "factory-report.xlsx");
        setLoading(false)
      }).catch((errpr) => {
        setLoading(false)})
  }
  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          โรงงาน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Factory
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Customer Support</Typography>
            <Typography>
              <span>&nbsp;</span> / Factory
            </Typography>
          </Grid>
        </Grid>

        <Grid
          style={{ marginTop: "10px", display: "flex", flexDirection: "row",justifyContent:'end' }}
        >
          {/* <DowloadBT /> */}

          <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                label="Search"
                onChange={(e) => setKey(e.target.value)}
                size="small"
              />
               <Button variant="outlined" disabled={loading}
            style={{ color: "#84BD5A", borderColor: "#84BD5A", marginLeft:'10px' }} onClick={() => download()}>
            <span className="material-icons-outlined">description</span>
            {loading ? 'Loading...' : 'Export'}</Button>
        </Grid>

        <Box
          sx={{
            height: 630,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.FactoryId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value === true ? "Active" : "Inactive";
              }
            }}
            // components={{
            //   Toolbar: CustomToolbar,
            // }}
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A022") && (
        <Link to="/CustomerSupport/AddFactory">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}
    </div>
  );
}
